export const colors = {
    Thriller: "#E26B01",
    "Self Help": "#48ABD1",
    Programming: "#212121",
    textBlack: "#000000",
    textGreyLight: "#8F8F8F",
    textGreyDark: "#464646"
  };
  